export const Bio = {
  name: "Jack McGrory",
  roles: [
    "a Software Developer",
    "a Front End Developer",
    "an API Engineer",
    "a Gamification Engineer",
    "interested in ..."
  ],
  description:
    "I’m a full-stack engineer specialising in gamified, educational experiences, with a background spanning APIs, Mobile, React and Unity development. I hold a Master of Engineering (Distinction) in Computer and Electronic Systems, where I achieved an A in every single module over the course of 5 years.",
  linkedin: "https://www.linkedin.com/in/jack-mcgrory-536b37165/",
};
export const skills = [
  {
    title: "Front End",
    skills: [
      { name: "TypeScript", image: "/ts.png" },
      { name: "React", image: "/react.png" },
      { name: "SASS/CSS", image: "/sass.png" },
      { name: "Rive", image: "/rive.png" },
      { name: "Unity", image: "/unity.png" }
    ],
  },
  {
    title: "Back End",
    skills: [
      { name: "Node.js", image: "/nodejs.png" },
      { name: "ExpressJS", image: "/express.png" },
      { name: ".NET", image: "/dotnet.png" },
      { name: "Java (Quarkus)", image: "/quarkus.png" },
      { name: "PostgreSQL", image: "/postgres.png" }
    ],
  },
  {
    title: "Automation & DevOps",
    skills: [
      { name: "Playwright", image: "/playwright.png" },
      { name: "Cypress", image: "/cypress.png" },
      { name: "Harness", image: "/harness.png" },
      { name: "AWS", image: "/aws.png" },
      { name: "Azure", image: "/azure.png" },
      { name: "Google Cloud (GCP)", image: "/gcp.png" },
      { name: "GitHub Actions", image: "/gha.png" }
    ],
  },
  {
    title: "Languages & Frameworks",
    skills: [
      { name: "TypeScript", image: "/ts.png" },
      { name: "Java", image: "/java.png" },
      { name: "Python", image: "/python.png" },
      { name: "C#", image: "/csharp.png" },
      { name: "Kotlin", image: "/kotlin.png" },
      { name: "Swift", image: "/swift.png" },
      { name: "TensorFlow / AI", image: "/tensortflow.png" }
    ],
  }
];

export const experiences = [
{
  id: -1,
  img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT4wdaEAWWLLLL6Je0QXqxDdGzO_dgRzrCdfA&s",
  role: "Software Engineer – Gamification",
  company: "Lloyds Banking Group",
  date: "October 2024 - Present",
  desc: [
    "Building gamified experiences to help people secure their financial future",
    "Full-stack experience across APIs, mobile, React, and Unity",
    "Pioneered the use of Rive, which brought millions in value through more interactive experiences",
    "Built DevOps pipelines to deploy services and run Playwright integration tests",
    "Shortlisted amongst top 5 engineers for Engineering Excellence in my first year"],
},
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRWSXqqaQFMUu7-PHXnYGaM5EiODKtNoteCWQ&s",
    role: "Computer and Electronic Systems (MEng) with Distinction",
    company: "University of Strathclyde",
    date: "June 2024",
    desc: ["Graduated with a 1st with a CWA of 84.6%", 
    "Achieved A's (>70%) in all modules over my 5 years",
     "Won 6 awards, including one for best student on the course and one for best group project in the department"],
  },
  {
    id: 1,
    img: "https://s3-eu-west-1.amazonaws.com/hackajob-uploads1.p.hackajob/branding/logo/QBO43NO9QZCV5fJwEHAj_1643364871897.jfif",
    role: "Take Home Pay Calculator Team - Intern",
    company: "xDesign",
    date: "June 2023 - September 2023",
    desc: ["Developed a Next.js application for all xDesign employees to help them calculate and visualise the amount of money their take home salary.", 
    "Presented to over 300 people in a hugely successfully launch at the company update.",
     "Learned TypeScript, CSS and C# for the first time and helped deliver a batch testing tool that verified the application via API’s"],
    skills: [
      "ReactJS",
      "SCSS",
      "NodeJs",
      "C#",
      "AWS Amplify",
      "BitBucket",
    ],
  },
  {
    id: 2,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRWSXqqaQFMUu7-PHXnYGaM5EiODKtNoteCWQ&s",
    role: "4th Year Dean's List",
    company: "University of Strathclyde",
    date: "June 2023",
    desc: ["Placed on the Dean's List for my high marks in 4th year", 
    "Completed my undergraduate dissertation on the development of an AI to detect Autism in young children via iPad games",
     "Was able to detect 90% of particpants who had Autism"],
    skills: [
      "AI Development",
      "TensorFlow",
      "Jupyter Notebook",
      "AI Evaluation Metrics",
      "xGBoost Models",
      "Feature Creation",
    ],
  },
  {
    id: 3,
    img: "https://asset.brandfetch.io/id3T02jwZd/idoURfZOJD.png",
    role: "Security and Connectivity Intern",
    company: "NXP Semiconductors",
    date: "June 2022 - September 2022",
    desc: ["Developed Java GUI application to detect configuration of an NXP chip and only apply suitable tests to the chip", 
    "Reworked framework of test suites so they can be included or excluded depending on the features used in each test case",
     "My mentor was extremely happy with the application and suggested that it could be used across the company to verify other products outside of the ones developed by my team"],
    skills: [
      "Java",
      "Java GUI's",
      "Inhouse Languages",
    ],
  },
  {
    id: 4,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRWSXqqaQFMUu7-PHXnYGaM5EiODKtNoteCWQ&s",
    role: "3rd Year Dean's List",
    company: "University of Strathclyde",
    date: "June 2022",
    desc: ["Placed on the Dean's List for my high marks in 3rd year", 
    "Worked in group project to create a barcode scanning pen and website from scratch",
     "Also developed a Boston Metro System Java application via Swing to give users travel directions"],
    skills: [
      "Java",
      "Swing",
      "A* Search",
      "Graphs",
      "XML"
    ],
  },
  {
    id: 5,
    img: "https://asset.brandfetch.io/id3T02jwZd/idoURfZOJD.png",
    role: "Secure Transactions and ID Intern",
    company: "NXP Semiconductors",
    date: "June 2021 - September 2021",
    desc: ["Helped automate the testing of contactless cards", 
    "Developed automated tool, utilising Windows Batch File code, to deliver weekly metrics on the amount of the products source code that was actually covered by the developed test suites",
     "The metrics were passed up to senior management who were delighted with my work and asked me to return next year"],
    skills: [
      "Java Card",
      "Windows Batch Code",
      "Macros"
    ],
  },
  {
    id: 6,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRWSXqqaQFMUu7-PHXnYGaM5EiODKtNoteCWQ&s",
    role: "1st and 2nd Year Dean's List",
    company: "University of Strathclyde",
    date: "June 2020 & June 2021",
    desc: ["Placed on the Dean's List for my high marks in both 1st and 2nd year", 
    "Achieved A's in all modules despite rapid change to online teaching halfway through 1st year"],
  },
  {
    id: 7,
    img: "https://upload.wikimedia.org/wikipedia/en/3/35/St_Peter_The_Apostle_High_School_crest.png",
    role: "Accepted to University",
    company: "St Peter the Apostle High School",
    date: "June 2019",
    desc: ["Recieved 5 unconditional offers to different universities", 
    "Achieved 15 A's across 3 Advanced Highers, 6 Highers and 6 National 5's",
     "Awarded the Lord McFall Outstanding Academic Acheivement Award for the highest marks in my year "],
  },

  
];


export const projects = [
  {
    id: 9,
    title: "Drive to Thrive",
    date: "February 2026",
    description: [
      "A Unity mini-game embedded into our React site to teach long-term investing confidence",
      "Players switch lanes and avoid obstacles while building the ‘confidence’ of their investment vehicle",
      "Originated from a winning idea at an ADA Scotland game jam focused on the gender pension gap",
      "Experience signposts key insights and educational content after gameplay"
    ],
    image: "/drivetothrive.png",
    link: {
text : "Play Drive to Thrive",
link: "https://www.powerup.scottishwidows.co.uk/drive-to-thrive",
}
  },
  {
    id: 10,
    title: "Roll with It",
    date: "January 2026",
    description: [
      "An interactive Rive experience explaining market volatility through motion and storytelling",
      "Visualises peaks, dips, and the importance of staying invested over the medium to long term",
      "Designed to be surfaced during periods of market uncertainty to reassure customers",
      "Demonstrates how animation can simplify complex financial concepts"
    ],
    image: "/rollwithit.png",
    link: {
text : "View Roll with It",
link: "https://www.powerup.scottishwidows.co.uk/market-changes",
}
  },
  {
    id: 11,
    title: "Pension Powerlift",
    date: "December 2025",
    description: [
      "An out-of-app educational experience built with React and Rive for the Pension Attention Campaign",
      "Includes a character creator with billions of possible combinations to drive personalisation",
      "Gamified gym journey teaches that growing a pension mirrors building strength over time",
      "Showcases scalable interactive storytelling outside the core banking app"
    ],
    image: "pensionPowerlift.png",
    link: {
text : "Play Pension Powerlift",
link: "https://www.powerup.scottishwidows.co.uk/pension-powerlift/",
}
  },
  {
    id: 12,
    title: "Pot Consolidation",
    date: "October 2025",
    description: [
      "One of the first in-app gamified journeys built using Rive to explain pension consolidation",
      "Cup-and-ball style interaction helps users track their pension through a shuffle mechanic",
      "Created millions in value by simplifying a traditionally complex financial process",
      "Proved the effectiveness of gamification within a regulated banking environment"
    ],
    image: "/potC.png",
  },
  {
    id: 0,
    title: "Robotic Greenkeeper",
    date: "Jan 2024 - Jun 2024",
    description:["I am delighted to finished my MEng Group Project where I worked in a team to help create a fully automated robotic greenkeeper for the maintenance of golf courses.","Over the past year Amir Hussain, Blair Kennedy, Jake Malcolm, Job Derksen and I conceptualised and developed a robot that can autonomously navigate around a course and automatically detect and repair pitchmarks on the green.","I helped develop the hosted NextJS application that shows the robots live location and allows greenkeepers to start scans and map new greens on their course. The application also provides a detailed nutrient breakdown of the soil and it has the ability to provide tailored treatment advice via a custom GPT assistant.","I also helped develop the software architecture for the microcontrollers to allow them to communicate with the web application as well as a computer vision model to detect and navigate to 85% of pitchmarks on the surface of the green.","We recently demonstrated the robot to a collection of industry experts at a tradeshow and it was exceptionally rewarding to receive such positive feedback to conclude my 5 years at the University of Strathclyde!"],
       image:
      "https://github.com/jackmcgrory/cvwebsiteresources/assets/51889186/1a56a933-433a-44d8-abb6-86b5a6ad8084",
      yvideo: "https://www.youtube.com/embed/abdqs39ClUo"
  },
  {
    id: 1,
    title: "CV Website",
    date: "Jun 2024",
    description:
      ["After finishing up with university, I began to develop this very website to act as a portfolio/CV for potential employers", "I developed the site using React and numerous libraries that were new to me such as ThreeJS, Styled-Components and more"],
    image:
      "https://github.com/jackmcgrory/cvwebsiteresources/assets/51889186/01e14894-eba0-47b6-b18e-8ca2229abf27",
  },
  {
    id: 2,
    title: "AI to Detect Autism",
    date: "Sept 2022 - May 2023",
    description:
      ["Delighted to complete my honours year project where I developed an AI model to detect autism in children based off their gameplay from an iPad game along with the results of some questions from their parents.", "The developed model was able to correctly identify 90% of participants with ASD (Autism Spectrum Disorder) which was a great achievement.","I also presented my results at a small seminar for ASD experts. I am very happy to have undertook such an exciting and impactful project at the University of Strathclyde "],
    image:
      "https://github.com/jackmcgrory/cvwebsiteresources/assets/51889186/6757b3f5-b59a-4611-b921-d2fb7831dfda",
  },
  {
    id: 4,
    title: "MyMedication App",
    date: "Sept 2023 - Dec 2023",
    description:
      ["For one of my 5th year classes I had to design an application for vulnerable people by following the User Centered Design process (UCD)", "Utilising Figma, I developed a medication aid that paired with pill boxes to guide people through the process of medication management", "This was my highest mark in 5th year, where I got 98% for the module"],
    image:
      "https://github.com/jackmcgrory/cvwebsiteresources/assets/51889186/651ebd05-e3d2-431e-ad5c-a5b3c6f470a6",

  },
  {
    id: 5,
    title: "Live Train Sign",
    date: "July 2023",
    description:
      ["In this small project I undertook in my own time, I used a Raspberry Pi Zero W and a small LCD display I had to display the live train times of my local station.","I utilised the National Rail Enquiries API to request information about train times as well as a handy application to format the data (as you would see at any train station) which I found on BalenaCloud"],
    image:
      "https://github.com/jackmcgrory/cvwebsiteresources/assets/51889186/e7aead65-8d32-41ae-b912-1b9557278d48",
      video: "https://github.com/jackmcgrory/cvwebsiteresources/assets/51889186/6cbd4497-7112-436c-bf91-52629f8b73b6"
  },
  {
    id: 6,
    title: "Supermarket Barcode Pen",
    date: "Jan 2022 - May 2022",
    description:
      ["In this 3rd year project, I developed a Bluetooth barcode scanning pen from a selection of components and software. The project started with an MSP-430 microcontroller to which we added serial Bluetooth communication with a HC-05 chip and also developed a Java application that could; Initiate a connection with the device; Read in the data into a string; close the connection.","Once this was enabled we then moved onto connecting a photodiode to the board and processing it via a Schmitt trigger circuit to remove any background noise in the signal. Then via ADC (analog to digital conversion) this signal was converted and sent to the Bluetooth chip.","Finally on the software side I developed an algorithm which would decode the binary string into the scanned EAN-13 barcode number. This involved pattern matching to estimate the size of one strip as well as determining what character was represented by the stripe sequence. Once the item number was obtained our code then added the item scanned to the users basket which appeared on a website for the user to monitor the total cost as well as delete and update their basket accordingly.","Finally to tidy things up we designed and manufactured our own PCB to implement the circuit components we had designed in a compact manner on top of the MSP-430."],
    image:
      "https://github.com/jackmcgrory/cvwebsiteresources/assets/51889186/4b79c6c0-9c78-433d-8fba-1406831a618c",
  },
  {
    id: 7,
    title: "Boston Metro System",
    date: "Sept 2021 - Dec 2021",
    description:
      ["In this 3rd year project, I developed a handy travel tool for users of the Boston Metro System using Java, Swing and XML.", "One of the key goals was to be completely abstract so that the designed system would work for any metro system and would only read in information about the metro system from a text file.", "The GUI application would then display a fully coloured map which users could click on to select stations (they could also type stations in or swap them round) and they would receive instructions on the shortest possible route between the two stations.","The algorithm used to find the shortest route was the A* Algorithm which would consider the time between stations rather than just the shortest route. However, it also considered that if you had to change line this would cost time too and this was factored in to delivering the shortest time."],
    image:
      "https://github.com/jackmcgrory/cvwebsiteresources/assets/51889186/8c0241ca-4163-4f19-8d2b-d06a7f15f26e",
      video: "https://github.com/jackmcgrory/cvwebsiteresources/assets/51889186/ca416d22-1b6b-4ce3-990a-e41856eb1723",
  },
  {
    id: 8,
    title: "Task Manager",
    date: "Sept 2021",
    description:
      ["In this shorter project I implemented a Task Manager GUI within the Java Virtual Machine.", "Here I learned the importance of concurrency and multithreading and implemented several features to filter through the types of threads, search for thread by name as well as the ability to add and kill named threads."],
    image:
      "https://github.com/jackmcgrory/cvwebsiteresources/assets/51889186/452cc5a7-2bae-429d-aecf-1fe7909e89e8",
  },
];

